import type { StatementRow } from '../../api/types'

export type StatementColumn = Exclude<keyof StatementRow, 'member_no' | 'period'>

/** The member view (M16): savings, income, value and loans by member number. */
export const MEMBER_COLUMNS: readonly StatementColumn[] = ['balance', 'income', 'closing_value', 'loan_principal']

/** The officer view (console): every column, with opening value, movements and net position. */
export const OFFICER_COLUMNS: readonly StatementColumn[] = ['opening_value', 'savings_in', 'savings_out', 'balance',
  'income', 'closing_value', 'loan_principal', 'loan_interest', 'receivables', 'net_position']
